export default "__VITE_ASSET__BzYdxN8x__"